import $ from 'jquery'
import TemplateView from "../TemplateView"
import ScollableContainer from '../util/ScrollableContainer'
import ScrollUtils from '../util/ScrollUtils'

class LightBoxWrapper extends TemplateView {
    constructor($el = $('body'), {
        id = '',
        header = null,
        content = null,
        footer = null,
        classNames = '',
        correctionOffset = 0
    }) {
        super($el)

        this.params = {
            id,
            header,
            content,
            footer,
            classNames,
            correctionOffset
        }
    }

    templateHtml() {
        return '<div id="<%=id%>" class="lightbox <%=additionalClasses%>" style="display:none">' +
               '    <div id="<%=id%>_content" class="content"></div>' +
               '</div>'
    }

    templateModel() {
        return {
            additionalClasses: this.params.classNames,
            id: this.params.id
        }
    }

    afterRender() {
        const $contentPlaceholder = this.find('.content')
        this.params.header.init($contentPlaceholder)
        this.scrollableContainer = new ScollableContainer(null, this.params.content, {triggerScrollEvent: true}).init($contentPlaceholder)
        this.params.footer.init($contentPlaceholder)

        // subscribe for user interraptions its need for sync ScrollableContainer
        // TODO we can sync ScrollableContainer by using only setState method for change data and presentation of View
        this.$el.on('keyup keydown keypress click mouseup mousedown', () => {
            this.scrollableContainer.forceUpdate()
        })
    }

    update() {
        this.scrollableContainer.forceUpdate()
    }

    scrollToSection = function($el) {
        this.scrollableContainer.scrollToElementVertical(
            $el,
            {
                pos: ScrollUtils.POSITIONS.TOP,
                offset: this.params.correctionOffset
            },
            600
        )
    }

    scrollToSectionIfNeeded($el) {
        if ($el.offset().top + $el.outerHeight() > this.scrollableContainer.getEl().offset().top +this.scrollableContainer.getEl().outerHeight())
            this.scrollToSection($el)
    }
}

export default LightBoxWrapper


// WEBPACK FOOTER //
// ./web/js/components/LightBoxWrapper.js